/**
 * consentmanager.net vendor ids, as configured for CMP 169747.
 *
 * Scripts tagged with these are held back until the visitor consents to that vendor.
 * The ids come from the CMP's own vendor list, not from a public registry — read them
 * from the dashboard (Menu > Vendors) rather than guessing if a new tracker is added.
 */
export const CMP_VENDOR = {
  googleAnalytics: 's26',
  facebook: 's7',
} as const;

/**
 * Marks a script element so the CMP activates it once consent covers `vendor`.
 *
 * `type="text/plain"` stops the browser executing it and, for external scripts, the URL
 * belongs in `data-cmp-src` rather than `src` so no request is made. Rendering the gated
 * form on both server and client keeps hydration stable — the CMP only rewrites these
 * nodes after consent, never during hydration.
 */
export function consentGatedScriptProps(vendor: (typeof CMP_VENDOR)[keyof typeof CMP_VENDOR]) {
  return {
    type: 'text/plain',
    className: 'cmplazyload',
    'data-cmp-vendor': vendor,
  } as const;
}
